import React, { Component } from 'react';
import { FormicaProps, withFormica } from '../../helpers/withFormica';
import { RootState } from '../../redux/store';
import { changeCurrentCategory, changeCurrentComponent, changeSidebarCollapse, toggleHamburgerMenu } from '../../redux/actions/PageActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import Icon from '../../icons/Icon';
import ComponentName from '../../constant/ComponentName';
import EnvironmentUtil from '../../util/EnvironmentUtil';
import { InstanceContainer } from '../../config/binding/InstanceBinding';
import Injectables from '../../constant/Injectables';
import RoleHelper from '../../RoleHelper';
import { SidebarMenuItemProps } from './SidebarMenuItem';
import SidebarMenuItemContainer from './SidebarMenuItemContainer';
import LanguageUtil from '../../util/LanguageUtil';

class WatchlistMenu extends Component<Props> {
  private readonly environmentUtil: EnvironmentUtil = InstanceContainer.get(Injectables.ENVIRONMENT_UTIL);

  private watchlist: SidebarMenuItemProps[] = [
    {
      name: LanguageUtil.get({ id: 'common.label.watchlist', defaultMessage: 'Watchlist' }),
      field: 'Watchlist',
      path: 'watchlist',
      icon: <Icon icon={'watchlist'} className={'text-f-black-2 group-hover:text-primary'} size={16} />,
      children: [],
      component: ComponentName.WATCHLIST,
      visible: this.environmentUtil.getWatchlist(),
    },
    {
      name: LanguageUtil.get({ id: 'common.label.alert', defaultMessage: 'Alert' }),
      field: 'WatchlistAlert',
      path: 'watchlist-alert',
      icon: <Icon icon={'watchlist-alert'} className={'text-f-black-2 group-hover:text-primary'} size={16} />,
      children: [],
      component: ComponentName.WATCHLIST_ALERT,
      visible: this.environmentUtil.getWatchlist(),
    },
    {
      name: LanguageUtil.get({ id: 'common.label.customList', defaultMessage: 'Custom List' }),
      field: 'CustomList',
      path: 'custom-list',
      icon: <Icon icon={'customlisticon'} className={'text-f-black-2 group-hover:text-primary'} size={16} />,
      children: [],
      component: ComponentName.CUSTOM_LIST,
      visible: this.environmentUtil.getWatchlist(),
    },
  ];

  public render() {
    const { collapsed, goPage, router } = this.props;
    const pathName = router.location.pathname.split('/')[1];
    const filteredWatchlist = this.watchlist.filter((m) => (m.visible != undefined ? m.visible : true) && RoleHelper.canView(m.field));
    if (filteredWatchlist?.length == 0) {
      return;
    }
    return (
      <SidebarMenuItemContainer items={filteredWatchlist} goPage={goPage} pathName={pathName} collapsed={collapsed} title={'KYC'} collapsedTitle={'KYC'} />
    );
  }
}

interface Props extends ReduxProps, FormicaProps {
  goPage(item: SidebarMenuItemProps): void;
}

const mapStateToProps = (state: RootState) => ({
  collapsed: state.page.sidebarCollapsed,
  page: state.page,
  component: state.component,
});
const mapDispatchToProps = {
  changeCurrentComponent,
  toggleHamburgerMenu,
  changeCurrentCategory,
  changeSidebarCollapse,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(WatchlistMenu));
